import script from "./LiveFixtureDoubleSecondMarketOverviewOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveFixtureDoubleSecondMarketOverviewOdd.vue?vue&type=script&setup=true&lang=js"

import "./LiveFixtureDoubleSecondMarketOverviewOdd.vue?vue&type=style&index=0&id=4343b15c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4343b15c"]])

export default __exports__